import { Component, OnInit } from '@angular/core';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { DatagridService, PagedResultGeneric, TranslationService, NotificationService } from 'src/app/shared';
import { CommitteeSearchDto } from '../shared/dto/committee-search.dto';
import { CommitteeDto } from '../shared/dto/committee.dto';
import { CommitteeService } from '../shared/committee.service';
import { MenuItem, ConfirmationService, SelectItem } from 'primeng/api';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';

@Component({
  selector: 'wl-committee-search-grid',
  templateUrl: './committee-search-grid.component.html',
  styleUrls: ['./committee-search-grid.component.less'],
  standalone: false,
})
export class CommitteeSearchGridComponent extends LazySelectableTableComponent<CommitteeSearchDto, CommitteeDto> implements OnInit {
  rowMenuItems = new Map<number, MenuItem[]>();
  pagingSizeItems: SelectItem[] = [];

  constructor(
    datagridService: DatagridService,
    private _committeeService: CommitteeService,
    private _translationService: TranslationService,
    private _notificationService: NotificationService,
    private _confirmationService: ConfirmationService,
    private _navigationService: NavigationService
  ) {
    super('CommitteeID', datagridService);
  }

  async ngOnInit(): Promise<void> {
    this.pagingSizeItems = [
      {
        label: await this._translationService.getTitlecase('common.page-size.show-20'),
        value: 20,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-100'),
        value: 100,
      },
      {
        label: await this._translationService.getTitlecase('common.page-size.show-all'),
        value: 9999,
      },
    ];
  }

  fetchResults(): Promise<PagedResultGeneric<CommitteeDto>> {
    return this._committeeService.search(this.searchParams);
  }

  clear() {
    this.searchParams = new CommitteeSearchDto();
    this.search();
  }

  committeeChanged(committee: CommitteeDto) {
    this._committeeService
      .update(committee)
      .then(() => {
        this._notificationService.translateSuccess('committees.search.committee-updated-message');
      })
      .catch((err) => {
        this._notificationService.httpError(err);
        this.search();
      });
  }

  actionItemsForCommittee(committee: CommitteeDto): MenuItem[] {
    if (!this.rowMenuItems.has(committee.CommitteeID)) {
      this.rowMenuItems.set(committee.CommitteeID, [
        {
          label: this._translationService.getInstantTitlecase('common.edit'),
          command: () => this.editCommittee(committee),
        },
        {
          label: this._translationService.getInstantTitlecase('common.delete'),
          command: () => this.deleteCommittee(committee),
        },
      ]);
    }
    return this.rowMenuItems.get(committee.CommitteeID);
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  private editCommittee(committee: CommitteeDto) {
    this._navigationService.navigateToCommitteeEdit(committee.CommitteeID);
  }

  private deleteCommittee(committee: CommitteeDto) {
    this._confirmationService.confirm({
      message: this._translationService.getInstantCapitalizeFirstCharacter('committees.search.confirm-delete-message'),
      key: 'deleteCommitteeCD',
      accept: () => {
        this.loading = true;
        this._committeeService.delete(committee.CommitteeID).then(
          () => {
            this._notificationService.translateSuccess('committees.search.committee-deleted');
            this.search();
          },
          (error) => {
            this._notificationService.httpError(error);
          }
        );
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
